<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Administration</div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container grid-list-xs>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.mdAndDown,
                    row: $vuetify.breakpoint.lgAndUp
                }"
                justify-space-between
            >
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/seasons" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">light_mode</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Seasons</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/teams" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">workspaces</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Teams</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/rosters" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">groups_2</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Rosters</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/divisions" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">safety_divider</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Divisions</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/matches" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">sports_baseball</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Matches</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/locations" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">place</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Locations</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/playoffs" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">emoji_events</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Playoffs</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/players" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">people</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Players</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/players_positions" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">person_pin</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Players Positions</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm3 ma-2>
                    <v-card to="/admin/players_stats" class="mb-2 pa-4" height="100%">
                        <v-layout column align-center>
                            <v-flex xs12>
                                <v-icon large color="black">insights</v-icon>
                            </v-flex>
                            <v-flex xs12>
                                <div class="subheading font-weight-bold text-xs-center">Manage Players Stats</div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'AdminHome',
    data() {
        return {}
    }
}
</script>

<style scoped></style>
